/**
 * International draughts, 10x10 — the FMJD standard.
 *
 * Draw rules follow the Official FMJD Rules for International Draughts,
 * Annex 1, articles 6.1-6.4. See `draw.ts` for the counters; the numbers
 * here are the article values.
 */
export const INTERNATIONAL = {
    id: "international",
    name: "International draughts",
    boardSize: 10,
    numSquares: 50,
    startRows: 4,
    menCaptureBackwards: true,
    flyingKings: true,
    promoteMidCapture: false,
    maximumCapture: true,
    drawRules: {
        repetition: 3, // 6.1
        noProgressPlies: 50, // 6.2 — 25 moves each side
        endgame3v1Moves: 16, // 6.3
        endgame2v1Moves: 5, // 6.4
    },
};
/**
 * Brazilian draughts, 8x8 — international rules on a smaller board.
 *
 * Kept in v1 so the variant abstraction is exercised by more than one case,
 * and because the existing 8x8 team tournaments use these rules.
 */
export const BRAZILIAN = {
    id: "brazilian",
    name: "Brazilian draughts",
    boardSize: 8,
    numSquares: 32,
    startRows: 3,
    menCaptureBackwards: true,
    flyingKings: true,
    promoteMidCapture: false,
    maximumCapture: true,
    drawRules: {
        repetition: 3,
        noProgressPlies: 50,
        endgame3v1Moves: null,
        endgame2v1Moves: null,
    },
};
export const VARIANTS = {
    international: INTERNATIONAL,
    brazilian: BRAZILIAN,
};
export function getVariant(id) {
    const v = VARIANTS[id];
    if (!v)
        throw new Error(`Unknown variant: ${id}`);
    return v;
}
